import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import ExpertRoutes from './routes/ExpertRoutes';
import CustomerRoutes from './routes/CustomerRoutes';
import LoginPage from './pages/LoginPage';
import LandingPage from './pages/customer/LandingPage';
import ProtectedRoute from './components/ProtectedRoute';
import { AppDispatch } from './store'
import 'react-datepicker/dist/react-datepicker.css';
import './App.css';
import { getAuth } from 'firebase/auth';
import { clearSignupData, getFirebaseApp, getSignupData } from './utils/firebase';
import { firebaseAuthStateChanged } from './redux/thunks/firebaseAuth';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00A699',
    },
    secondary: {
      main: '#484848',
    },
  },
});

function App() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const auth = getAuth(getFirebaseApp());
    const unsubscribe = auth.onIdTokenChanged((user) => {
      const signupData = getSignupData();
      if (user) {
        user.getIdTokenResult()
          .then((idTokenResult) => {
            dispatch(firebaseAuthStateChanged({
              authData: {
                authId: user.uid,
                tokens: {
                  accessToken: idTokenResult.token,
                }
              },
              signupData,
            }))
            clearSignupData();
          })
          .catch(error => {
            console.log(error);
          })
      } else {
        // Notify app of new access token
        dispatch(firebaseAuthStateChanged({
          authData: {
            authId: null,
            tokens: {
              accessToken: null,
            }
          },
          signupData: null,
        }))
      }
    })

    return () => unsubscribe();

  }, [dispatch])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Expert routes - protected */}
          <Route
            path="/expert/*"
            element={
              <ProtectedRoute>
                <ExpertRoutes />
              </ProtectedRoute>
            }
          />

          {/* Customer routes */}
          <Route path="/:businessSlug?/:expertSlug/*" element={<CustomerRoutes />} />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
